import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.postForm(
    `/incidents/${incidentId}/incident_risk_assumptions`,
    data,
  )
}

const update = async ({ incidentId = '', id = '', ...data }) => {
  return await dponetAPI.putForm(
    `/incidents/${incidentId}/incident_risk_assumptions/${id}`,
    data,
  )
}

const changeRiskAssumed = async ({ incidentId = '', id = '', ...data }) => {
  return await dponetAPI.putForm(
    `/incidents/${incidentId}/incident_risk_assumptions/${id}/change_risk_assumed`,
    data,
  )
}

const destroyAttachment = async ({ incidentId = '', id = '', ...params }) => {
  return await dponetAPI.delete(
    `/incidents/${incidentId}/incident_risk_assumptions/${id}/attachments`,
    { params },
  )
}

const incidents = {
  changeRiskAssumed,
  create,
  destroyAttachment,
  update,
}

export default incidents
